import React from 'react';
import { motion } from 'framer-motion';
import ShareBlogButton from '../../../components/ShareBlogButton/ShareBlogButton';
import './cloudvendor-app-using-java-springboot-using-mysql-jdbc.css';
import cloudVendorImg from '../../../assets/images/CloudVendor App Image.png';

const CloudVendorAppBlog = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        CloudVendor App using <span>Java Spring Boot</span> & MySQL JDBC
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <br />
        Published On: 20th June 2025<br />
        🕒 Last Updated On: 20th June 2025
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={cloudVendorImg} alt="CloudVendor App" className="project-image" />
          <h2 className="project-subtitle">CloudVendor Management App</h2>
          <span className="project-category">Backend Development</span>
          <p className="project-author">Author: Praveen Kumar B</p>
          <p className="project-author">🕒 3 Mins Read</p>
          <div className="blog-action-buttons">
            <a href="https://github.com/Praveenkumar-king/Java-Springboot-JDBC-powered-CloudVendor-app" className="visit-project-button">→ Visit the Project</a>
            <ShareBlogButton
              blog={{
                id: "cloudvendor-app-using-java-springboot-using-mysql-jdbc",
                title: "CloudVendor Management App",
                path: "/blogs/blogdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc",
                category: "Backend Development"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Introduction ✨</h3>
          <p className="overview-text">
            In today’s cloud-driven world, managing vendor data efficiently is key to operational success. The <strong>CloudVendor App</strong> was developed to streamline the creation, retrieval, updating, and deletion (CRUD) of cloud vendor records using Java Spring Boot and MySQL JDBC.
          </p>

          <h3 className="section-title">What Problem Are We Solving?</h3>
          <p className="overview-description">
            Many businesses rely on cloud vendors for storage, computing, and networking. But managing vendor data is often done manually or through rigid systems. We aimed to build a RESTful backend that makes this process flexible, scalable, and database-driven.
          </p>

          <h3 className="section-title">Application Architecture 🏗️</h3>
          <p>
            The app follows a layered architecture:
          </p>
          <ul className="feature-list">
            <li><strong>Controller Layer:</strong> Handles REST API requests.</li>
            <li><strong>Service Layer:</strong> Contains business logic.</li>
            <li><strong>Repository Layer:</strong> Manages data using JDBC with MySQL.</li>
            <li><strong>Model Layer:</strong> Defines CloudVendor objects.</li>
          </ul>

          <h3 className="section-title">CRUD Features Implemented ✅</h3>
          <ul className="feature-list">
            <li><strong>CREATE:</strong> Add new vendors with name, location, and service description.</li>
            <li><strong>READ:</strong> View all vendors or fetch one by ID.</li>
            <li><strong>UPDATE:</strong> Modify vendor details with ease.</li>
            <li><strong>DELETE:</strong> Remove vendors cleanly from the system.</li>
            <li><strong>DATABASE SYNC:</strong> All actions are synced in real-time with the MySQL database.</li>
          </ul>

          <h3 className="section-title">Technologies Used 💻</h3>
          <ul className="how-it-works-list">
            <li>Java 17</li>
            <li>Spring Boot Framework</li>
            <li>Spring Web & Spring JDBC</li>
            <li>MySQL Database</li>
            <li>Postman for API Testing</li>
            <li>IntelliJ / Eclipse IDE</li>
          </ul>

          <h3 className="section-title">Project Highlights 🌟</h3>
          <ul className="benefits-list">
            <li>Clean and RESTful API design.</li>
            <li>Strong separation of concerns using layered architecture.</li>
            <li>Robust error handling and HTTP status codes.</li>
            <li>Quick integration with frontend or third-party systems.</li>
            <li>Easy scalability and maintainability.</li>
          </ul>

          <h3 className="section-title">How It Works 🔍</h3>
          <ul className="how-it-works-list">
            <li>Frontend or REST client sends request to the controller.</li>
            <li>Service layer processes the logic and validates data.</li>
            <li>Repository layer uses JDBC to interact with MySQL.</li>
            <li>Response is returned in JSON format with proper status code.</li>
          </ul>

          <h3 className="section-title">Why You’ll Love This Project ❤️</h3>
          <ul className="benefits-list">
            <li>Perfect learning project for backend development.</li>
            <li>Follows real-world enterprise standards.</li>
            <li>Teaches you how to build CRUD APIs from scratch.</li>
            <li>Easy to extend into microservices or deploy with Docker.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>
            The <strong>CloudVendor App</strong> serves as a foundational project to understand how to build robust backend APIs using Spring Boot and JDBC. Whether you're a backend enthusiast or preparing for real-world development, this app sets the stage for scalable, secure, and structured backend systems.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CloudVendorAppBlog;
